import { Grid } from '@material-ui/core';
import { StatRow } from '@screens/players/stat.display';
import React from 'react';
import { formatStringDate } from '@domain/utils/format.utils';
import { TourneyDataProps } from '@screens/tourneys/tourney.data.props';

const TourneyInfosRex = ({ tourneyInfo }: TourneyDataProps) => {
  const formatStartDate = formatStringDate(tourneyInfo.startDate || '');
  const formatClosureDate = formatStringDate(tourneyInfo.closureDate || '');
  const coolingDate = formatStringDate(tourneyInfo.coolingDate || '');

  const scheduledStartDate = formatStringDate(tourneyInfo.scheduledStartDate || '');
  const scheduledCoolingDate = formatStringDate(tourneyInfo.scheduledCoolingDate || '');
  const scheduledClosureDate = formatStringDate(tourneyInfo.scheduledClosureDate || '');
  return (
    <div style={{ padding: 20 }}>
      <Grid container alignItems='center' justify='space-evenly' spacing={3}>
        <Grid item xs>
          <StatRow label='Tourney Id'>{tourneyInfo.tourneyId}</StatRow>
        </Grid>
        <Grid item xs>
          <StatRow label='Scheduled Start Date'>{scheduledStartDate}</StatRow>
        </Grid>
      </Grid>
      <Grid container alignItems='center' justify='space-evenly' spacing={3}>
        <Grid item xs>
          <StatRow label='Tourney Shedule Id'>{tourneyInfo.tourneyScheduleId}</StatRow>
        </Grid>
        <Grid item xs>
          <StatRow label='Scheduled Cooling Date'>{scheduledCoolingDate}</StatRow>
        </Grid>
      </Grid>
      <Grid container alignItems='center' justify='space-evenly' spacing={3}>
        <Grid item xs>
          <StatRow label='Start Date'>{formatStartDate}</StatRow>
        </Grid>
        <Grid item xs>
          <StatRow label='Scheduled Closure Date'>{scheduledClosureDate}</StatRow>
        </Grid>
      </Grid>
      <Grid container alignItems='center' justify='space-evenly' spacing={3}>
        <Grid item xs>
          <StatRow label='Cooling Date'>{coolingDate}</StatRow>
        </Grid>
      </Grid>
      <Grid container alignItems='center' justify='space-evenly' spacing={3}>
        <Grid item xs>
          <StatRow label='Closure Date'>{formatClosureDate}</StatRow>
        </Grid>
      </Grid>
    </div>
  );
};

export default TourneyInfosRex;
